/**
 * Floating of element on top if out of viewport
 *
 * todo: remove jquery dependency, resize handling, container (children) dependency
 */
angular.module("common.directives.floating", []).directive('floating', function ($window) {
    return {
        scope: {
        },
        link: function (scope, element, attrs) {
            var container = element;
            container.css("display", "block");
            var floatingObject = element.children();

            var setPositioning = function () {
                //container.css("min-height", "71px");
                var elementPosition = element.offset(); // jquery
                var elementWidth = container.css('width');
                // var elementHeight = element.height();
                if (angular.element($window).scrollTop() > elementPosition.top) {
                    floatingObject.css('position', 'fixed').css('top', '5px');
                    floatingObject.css('width', elementWidth);
                    floatingObject.css('z-index', 1000);
                    container.css("height", floatingObject.css("height"));

                } else {
                    floatingObject.css('position', 'static');
                    container.css("height", "auto");
                }
            };

            setPositioning(); // inital

            angular.element($window).scroll(function () {
                setPositioning();
            });
        }
    };
});